/* eslint-disable max-classes-per-file */
import { TransformPlainObject } from './transform.plainObject';

export class ColumnMappingBaseTransformPlainObject extends TransformPlainObject {
    public rules: RuleBasedMappingPlainObject[] = [];
    public mappings: ColumnMappingPlainObject[] = [];
}

export class RuleBasedMappingPlainObject {
    public unEscapedRegexString: string;
    public templateCondition: string;
    public columnNameExpression: string;
    public hierarchyLevelExpression: string;
    public deepHierarchy: boolean;
    public rowIndex: number;
}

export class ColumnMappingPlainObject {
    public name: string;
    public alias: string;
    public isField: boolean;
    public isArraySelector: boolean;
    public rowIndex: number;
}
